module.exports = __webpack_public_path__ + "files/c067e19c51a6a51e8497dd781075f9a2.png";